var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-colorError MuiSvgIcon-fontSizeMedium css-11icg0y-MuiSvgIcon-root e1de0imv0",
    "data-testid": "ErrorIcon",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    fill: "#fff",
    d: "M9.133 5.16h6.831v12.944H9.133z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export default ForwardRef;